import React from 'react';
import { Routes, Route } from 'react-router-dom';

const HealthSection: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <div className="min-h-screen bg-theme-secondary pb-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="py-8">
                <h1 className="text-3xl font-bold text-theme-primary mb-2">
                  Health Tracking
                </h1>
                <p className="text-theme-secondary mb-8">
                  Health mini apps
                </p>
                <div className="rounded-lg border border-theme-primary bg-theme-primary p-6 text-theme-secondary">
                  No health mini apps yet.
                </div>
              </div>
            </div>
          </div>
        }
      />
    </Routes>
  );
};

export default HealthSection; 